import {secondsToHms} from '@netx/core-next/utils/time';

/**
 * @param duration Duration in milliseconds
 * @returns Duration label
 */
export const getMediaFileTypeAssetInfoLabel = (duration: number) =>
	secondsToHms(duration / 1000);

export default getMediaFileTypeAssetInfoLabel;
